export default __webpack_public_path__ + "static/media/patientImg.c34bf552.svg";